module.exports = __webpack_public_path__ + "fe4d68abe779194c24367afa9357e766.woff2";


//////////////////
// WEBPACK FOOTER
// ./markup/fonts/roboto/roboto-medium.woff2
// module id = 1068
// module chunks = 0